import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';

import * as myConstClass from '../../shared/constants/constants';

const CST_FIELDS_8B = [
	{ field: 'date', header: 'Date', decimals: -1 },
	{ field: 'seasonName', header: 'Saison', decimals: -1 },
	{ field: 'teamName', header: 'Équipe', decimals: -1 },
	{ field: 'partnersName', header: 'Partenaire', decimals: -1 },
	{ field: 'opponentsName',	header: 'Adversaire', decimals: -1 },
	{ field: 'gamesPlayed', header: 'PJ', decimals: -1 },
	{ field: 'ips', header: 'IPS', decimals: 0 },
	{ field: 'fp', header: 'FP', decimals: 2 },
	{ field: 'avg', header: 'MOY', decimals: 2 },
	{ field: 'gamesWon', header: 'VIC', decimals: -1 },
	{ field: 'gamesLost', header: 'DEF', decimals: -1 },
	{ field: 'pctWin', header: '% VIC',	decimals: 1 },
	{ field: 'pointsFor', header: 'PP', decimals: -1 },
	{ field: 'pointsAgainst', header: 'PC', decimals: -1 },
	{ field: 'diff', header: 'DIFF', decimals: -1 },
	{ field: 'ero', header: 'EP', decimals: -1 },
	{ field: 'eroContre', header: 'EC', decimals: -1 },
	{ field: 'tv', header: 'TVP', decimals: -1 },
	{ field: 'tvContre', header: 'TVC', decimals: -1 },
];

const CST_FIELDS_9B = [
	{ field: 'date', header: 'Date', decimals: -1 },
	{ field: 'seasonName', header: 'Saison', decimals: -1 },
	{ field: 'teamName', header: 'Équipe', decimals: -1 },
	{ field: 'partnersName', header: 'Partenaire', decimals: -1 },
	{ field: 'opponentsName',	header: 'Adversaire', decimals: -1 },
	{ field: 'gamesPlayed', header: 'PJ', decimals: -1 },
	{ field: 'avg', header: 'MOY', decimals: 2 },
	{ field: 'gamesWon', header: 'VIC', decimals: -1 },
	{ field: 'gamesLost', header: 'DEF', decimals: -1 },
	{ field: 'pctWin', header: '% VIC',	decimals: 1 },
	{ field: 'pointsFor', header: 'PP', decimals: -1 },
	{ field: 'pointsAgainst', header: 'PC', decimals: -1 },
	{ field: 'diff', header: 'DIFF', decimals: -1 },
];

const PAGER_DISPPAGES = 4;
const PAGER_PAGESIZE = 10;

class DashMod_MatchResults01 extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			tableFields: [],
			resultTableData: [],
			sortFieldIdx: 0,
			sortOrder: 'desc',	// date desc by default
			sortClass: [],
			pager: {
				startIndex: 0,
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				endIndex: PAGER_PAGESIZE - 1,
				totalItems: 0
			},
			loading: true
		};
	
		this.createTableRow = this.createTableRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
		this.displayHeader = this.displayHeader.bind(this);
	}

	componentDidMount() {
    // console.log('DashMod01: componentDidMount');
    if (this.props.playerId) {
      this.initiatePagerSizeWithData();
    } else {
      this.setState({ loading: false });
    }
	}

  componentDidUpdate(prevProps) {
    if (
      prevProps.playerId !== this.props.playerId ||
      prevProps.resultsType !== this.props.resultsType ||
      prevProps.leagueType !== this.props.leagueType
    ) {
      if (this.props.playerId) {
        this.initiatePagerSizeWithData();
      } else {
        this.setState({ loading: false, resultTableData: [], pager: { ...this.state.pager, totalItems: 0, totalPages: 0, pages: [] } });
      }
    }
  }

	initiatePagerSizeWithData() {
    //console.log('DashMod01: initiatePagerSizeWithData');
    const { playerId, resultsType, leagueType } = this.props;
		var sortClass = [];
		var tableFields = this.getTableFields();

		for (var i = 1; i < (tableFields.length - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[this.state.sortFieldIdx] = "statelo-sorting_" + this.state.sortOrder;

    if (!playerId) {
      this.setState({ loading: false });
      return;
    }

		this.setState({
			sortClass: sortClass,
      loading: true,
		});

		Axios.get('/api/dashmod/playerMatchResults/size/playerId/' + playerId + '/resultsType/' + 
			resultsType	+ '/leagueType/' + leagueType).then(response => {
			
			// Init pager
			var pager = {
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				startindex: 0,
				endIndex: PAGER_PAGESIZE-1,
				totalItems: response.data.count,
			};

			this.setPage(1, pager);
		});
	}

  setPage(page, pager) {
    // console.log('DashMod01: setPage');
  	// set optional parameters
      var pager = pager || this.state.pager;

      if (page < 1 || page > pager.totalPages) {
      	console.log('************ ERR *************');
      	console.log('setPage unexpected return');
      	return;
      }

      // get new pager object for specified page
      pager = this.getPager(pager.totalItems, page);

      // call change page function in parent component
      this.loadData(pager, this.state.sortFieldIdx, this.state.sortOrder);
  }

  getPager(totalItems, currentPage, pageSize) {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || PAGER_PAGESIZE;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    var startPage, endPage;
    if (totalPages <= PAGER_DISPPAGES) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= ((PAGER_DISPPAGES / 2) + 1)) {
        startPage = 1;
        endPage = PAGER_DISPPAGES;
      } else if (currentPage + ((PAGER_DISPPAGES / 2) - 1) >= totalPages) {
        startPage = totalPages - (PAGER_DISPPAGES - 1);
        endPage = totalPages;
      } else {
        startPage = currentPage - Math.ceil(PAGER_DISPPAGES / 2);
        endPage = currentPage + Math.ceil((PAGER_DISPPAGES / 2) - 1);
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    // var pages = _.range(startPage, endPage + 1);		// lodash function
 		var pages = Array.apply(0, Array(endPage - startPage + 1)).map(function (element, index) { 
    	return index + startPage;  
  	});
    
    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

	loadData(pager, sortFieldIdx, sortOrder) {
		document.body.classList.add('busy-cursor');
    const { playerId, resultsType, leagueType } = this.props;

		var tableFields = this.getTableFields();
		var sortFieldName = tableFields[sortFieldIdx].field;
		var partnersNotEmpty = false;

		Axios.get('/api/dashmod/playerMatchResults/playerId/' + playerId + 
			'/resultsType/' + resultsType + '/leagueType/' + leagueType + 
			'/start/' + pager.startIndex + '/end/' + (pager.endIndex + 1) + 
			'/sortFieldName/' + sortFieldName + '/sortOrder/' + sortOrder).
			then(response => {

				// console.log('response.data');
				// console.log(response.data);

				// check if any partners
				var resultTableData = response.data;
				for (var idx = 0; idx < resultTableData.length; idx++) {

					// console.log(resultTableData[idx].partnersName);
					if (resultTableData[idx].partnersName !== '') {
						partnersNotEmpty = true;
						break;
					}
				}

				this.setState({
					pager: pager,
					resultTableData: resultTableData,
					partnersNotEmpty: partnersNotEmpty,
					loading: false
				});
				document.body.classList.remove('busy-cursor');
		});	
	}

	render() {
		// console.log('DashMod_MatchResults01: render');
		if (!this.props.playerId) return null;

    var pager = this.state.pager;
		var bDispModule = true;
    if (pager.pages.length < 1) {
    	bDispModule = false;
    } 

		return (
			<div className="row db-module-outer-dark">
			<div className="col-12">

				<div className="row">
				<div className="col-12 text-center">
					<h4 className="db-module-title-dark">Vos statistiques de matchs</h4>
				</div>
				</div>

				<div className="row db-module-inner-dark">
				<div className="col-md-12 db-module-inner-col-padding">
				<div className="card db-module-inner-card-dark">
					{bDispModule ? this.displayModule(pager) : 
						<div>
						<p>Aucun match joué</p>
						</div>
					}
				</div>
				</div>
				</div>
			</div>
			</div>
		)
	}

	displayModule(pager) {
		if (this.state.loading) {
			return (
				<div className="text-center"> 
					<i> données en chargement </i>
					{this.displaySpinner()}
				</div>
			);
		} else {
			return ( this.displayData(pager) );
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	displayData(pager) {
    const { resultTableData } = this.state;
		var tableFields = this.getTableFields();
		var bDispPagination = true;
    if (pager.pages.length < 2) {
			bDispPagination = false;
		}

		return (
     	<div>
			<p>{pager.totalItems} matchs joués</p>
			
			<div className="table-responsive">
			<table className="table table-striped table-hover table-sm">
			<thead>
				<tr>
					{tableFields.map(this.displayHeader)}
				</tr>
			</thead>

			<tbody>
				{resultTableData.map(this.createTableRow)}
			</tbody>
			</table>
			</div>

			{bDispPagination ? this.displayPagination(pager) : null}

			<span>* La colonne <i>Partenaire</i> s'affichera seulement pour les parties jouées en équipe (certaines ligues ou tournois seulement)</span>
			</div>
		);
	}

	displayHeader(hdrItem, hdrIdx) {
		var { sortClass, partnersNotEmpty } = this.state;
		// do not show column if no partners
		if (!partnersNotEmpty && (hdrItem.field === 'partnersName')) {
			return;
		}
		return (
			<th key={'hdr.' + hdrIdx} id={"colid." + hdrIdx} className={"statelo-sorting " + sortClass[hdrIdx]} onClick={this.handleSortTable}> {hdrItem.header} </th>
		);
	}

	displayPagination(pager) {
		return (
	    <ul className="pagination">
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(1)}>{"<<"}</a>
        </li>
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage - 1)}>{"<"}</a>
        </li>
        {pager.pages.map((page, index) =>
          <li key={index} className={pager.currentPage === page ? 'active' : ''}>
            <a onClick={() => this.setPage(page)}>{page}</a>
          </li>
        )}
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage + 1)}>{">"}</a>
        </li>
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.totalPages)}>{">>"}</a>
        </li>
	    </ul>
		);
	}

	createTableRow(resultDataRow, rowIdx) {
		var tableFields = this.getTableFields();
		return (
			<tr key={'te.' + rowIdx}>
				{tableFields.map(this.createDataCell.bind(this, resultDataRow))}
      </tr>
    );
	}

	createDataCell(rowItem, datacell, dataIdx, datacells) {
		var data = rowItem[datacell.field];

		// do not show column if no partners
		if (!this.state.partnersNotEmpty && (datacell.field === 'partnersName')) {
			return;
		}

		if (datacell.field === 'date') {
			data = moment(data).utc().format("YYYY-MM-DD");
		}

		if (datacell.field === 'date') {
			data = moment(data).utc().format("YYYY-MM-DD");
		}

		// Fixed number of decimals, converting to string, for averages or any other stats
		if (datacell.decimals !== -1) {
			data = data.toFixed(datacell.decimals);
		}

		return (
			<td key={'td.' + dataIdx}> {data} </td>
		);
	}

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var { sortOrder, sortFieldIdx, pager } = this.state;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			if (colIdx === 2) {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		}

		var sortClass = [];
		var tableFields = this.getTableFields();
		for(var i = 0; i < (tableFields.length - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: colIdx,
			sortClass: sortClass
		});

    this.loadData(pager, colIdx, sortOrder);
	}

	getTableFields() {
    const { leagueType } = this.props;
    if ((leagueType === myConstClass.LGTYPE_8B) || (leagueType === myConstClass.LGTYPE_10B)) {
    	return CST_FIELDS_8B;
    }
    if (leagueType === myConstClass.LGTYPE_9B) {
    	return CST_FIELDS_9B;
    }
	}

}

export default DashMod_MatchResults01;
